export const MARKETPLACES = {
  global: [
    {
      id: "amazon",
      name: "Amazon",
      description: "La plus grande marketplace au monde, présente dans de nombreux pays."
    },
    {
      id: "ebay",
      name: "eBay",
      description: "Plateforme mondiale de vente en ligne, idéale pour l'international."
    },
    {
      id: "etsy",
      name: "Etsy",
      description: "Marketplace spécialisée dans les produits artisanaux et créatifs."
    },
    {
      id: "pinterest_shop",
      name: "Pinterest Shop",
      description: "Plateforme idéale pour les produits visuels avec un fort potentiel de conversion."
    },
    {
      id: "whatsapp_business",
      name: "WhatsApp Business",
      description: "Solution de messagerie et catalogue produits intégrée pour une vente directe."
    },
    {
      id: "linkedin_shop",
      name: "LinkedIn Shop",
      description: "Marketplace B2B pour atteindre une clientèle professionnelle."
    },
    {
      id: "snapchat_shop",
      name: "Snapchat Shop",
      description: "Plateforme de commerce social ciblant principalement la génération Z."
    }
  ],
  usa: [
    {
      id: "walmart",
      name: "Walmart Marketplace",
      description: "Plus grand détaillant physique des États-Unis avec une forte présence en ligne."
    },
    {
      id: "target",
      name: "Target Plus",
      description: "Plateforme de vente en ligne du géant américain Target."
    }
  ],
  europe: [
    {
      id: "cdiscount",
      name: "Cdiscount",
      description: "Une des principales marketplaces en France."
    },
    {
      id: "allegro",
      name: "Allegro",
      description: "Leader du e-commerce en Europe centrale et de l'Est."
    },
    {
      id: "zalando",
      name: "Zalando",
      description: "Principale plateforme de mode en Europe."
    }
  ],
  asia_pacific: [
    {
      id: "flipkart",
      name: "Flipkart",
      description: "Leader du e-commerce en Inde."
    },
    {
      id: "rakuten",
      name: "Rakuten",
      description: "Grande marketplace japonaise avec présence internationale."
    },
    {
      id: "shopee",
      name: "Shopee",
      description: "La plus grande plateforme de commerce électronique en Asie du Sud-Est."
    }
  ],
  latin_america: [
    {
      id: "mercadolibre",
      name: "Mercado Libre",
      description: "La plus grande marketplace d'Amérique Latine, présente dans 18 pays."
    }
  ],
  africa: [
    {
      id: "jumia",
      name: "Jumia",
      description: "Plus grande marketplace d'Afrique."
    },
    {
      id: "glovo",
      name: "Glovo",
      description: "Plateforme de livraison rapide en ville."
    },
    {
      id: "jiji",
      name: "Jiji",
      description: "Marketplace de petites annonces populaire en Afrique."
    }
  ]
};